import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "fallback", "fileName"]

  disconnect() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
  }

  preview() {
    const file = this.inputTarget.files?.[0]
    if (!file) return

    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = URL.createObjectURL(file)

    this.previewTarget.src = this.objectUrl
    this.previewTarget.classList.remove("hidden")
    this.fallbackTarget.classList.add("hidden")
    if (this.hasFileNameTarget) this.fileNameTarget.textContent = file.name
  }
}
